export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:created', () => {
        sessionStorage.clear();
    });
})
